import { MarkerData } from "../types/markers";

export const markers: MarkerData[] = [
  {
    location: "Warsaw",
    coords: [ 21.012230, 52.229675 ],
  },
  {
    location: "Gdansk",
    coords: [ 18.638306, 54.372158 ],
  },
  {
    location: "Krakow",
    coords: [ 19.944544, 50.049683 ],
  },
  {
    location: "London",
    coords: [ -0.118092, 51.509865 ],
  },
  {
    location: "Birmingham",
    coords: [ -1.898575, 52.489471 ],
  },
  {
    location: "Berlin",
    coords: [ 13.404954, 52.520008 ],
  },
  {
    location: "Madrid",
    coords: [ -3.703790, 40.416775 ],
  },
  {
    location: "Barcelona",
    coords: [ 2.154007, 41.390205 ],
  },
  {
    location: "Cadiz",
    coords: [ -6.283333, 36.533333 ]
  },
  {
    location: "Faro",
    coords: [ -7.930440, 37.019356 ],
  },
  {
    location: "Rome",
    coords: [ 12.496366, 41.902782 ],
  },
  {
    location: "Milan",
    coords: [ 9.188540, 45.464664 ],
  },
  {
    location: "Venice",
    coords: [ 12.327145, 45.438759 ],
  },
  {
    location: "Athens",
    coords: [ 23.727539, 37.983810 ],
  },
  {
    location: "Crete",
    coords: [ 24.530005, 35.417416 ],
  },
  {
    location: "Santorini",
    coords: [ 25.461510, 36.393154 ],
  },
  {
    location: "Abersywyth",
    coords: [ -4.083116, 52.415089 ],
  },
  {
    location: "Edinburgh",
    coords: [ -3.188267, 55.953251 ],
  },
  {
    location: "Glasgow",
    coords: [ -4.251433, 55.860916 ],
  },
  {
    location: "Budapest",
    coords: [ 19.040236, 47.497913 ],
  },
  {
    location: "Kyiv",
    coords: [ 30.523333, 50.450001 ],
  },
  {
    location: "Madeira",
    coords: [ -16.274998, 32.371666 ],
  },
  {
    location: "Stockholkm",
    coords: [ 18.063240, 59.334591 ],
  },
  {
    location: "Helsinki",
    coords: [ 24.945831, 60.192059 ],
  },
  {
    location: "Talinn",
    coords: [ 24.753574, 59.436962 ],
  },
  {
    location: "Istanbul",
    coords: [ 28.979530, 41.015137 ],
  },
  {
    location: "Bangkok",
    coords: [ 100.523186, 13.736717 ],
  },
  {
    location: "Pattaya",
    coords: [ 100.877083, 12.927608 ],
  },
  {
    location: "Los Angeles",
    coords: [ -118.243683, 34.052235 ],
  },
  {
    location: "San Francisco",
    coords: [ -122.431297, 37.773972 ],
  },
  {
    location: "Brisbane",
    coords: [ 153.021072, -27.470125 ],
  },
  {
    location: "Sydney",
    coords: [ 151.20990, -33.865143 ],
  },
  {
    location: "Melbourne",
    coords: [ 144.946457, -37.840935 ],
  },
  {
    location: "Reykjavik",
    coords: [ -21.862675, 64.135666 ],
  },
  {
    location: "Tokyo",
    coords: [ 139.839478, 35.652832 ],
  },
  {
    location: "Osaka",
    coords: [ 135.484802, 34.672314 ],
  },
  {
    location: "Ho Chi Minh City",
    coords: [ 106.660172, 10.762622 ]
  },
  {
    location: "Singapore",
    coords: [ 103.851959, 1.290270 ]
  },
  {
    location: "Kuala Lumpur",
    coords: [ 101.693207, 3.140853 ]
  },
  {
    location: "Bali",
    coords: [ 115.188919, -8.409518 ]
  },
  {
    location: "Amsterdam",
    coords: [ 4.897070, 52.377956 ]
  }
]
